import { createRouter, createWebHistory } from 'vue-router'

const asyncRouterConfig = [
    // 登录
    {
        path: '/',
        name: 'Login',
        component: () => import(/* webpackChunkName: "login" */ '../views/Login/index.vue'),
        meta: { title: '登录' }
    },
    {
        path: '/LayoutHome',
        name: 'LayoutHome',
        component: () => import(/* webpackChunkName: "LayoutHome" */ '../components/LayoutHome/index.vue'),
        meta: { title: '大框架' },
        children: []
    },
    {
        path: '/platform-ai',
        name: 'platform-ai',
        component: () => import(/* webpackChunkName: "platform-ai" */ '../views/platform-ai/index.vue'),
        meta: { title: 'AI平台' },
        children: [
            {
                path: '',
                redirect: 'ai-dashboard'
            },
            {
                path: '/ai-dashboard',
                name: 'ai-dashboard',
                component: () => import(/* webpackChunkName: "ai-dashboard" */ '../views/platform-ai/ai-dashboard/index.vue'),
                meta: { title: '首页' }
            },
            {
                path: '/ai-map',
                name: 'ai-map',
                component: () => import(/* webpackChunkName: "ai-map" */ '../views/platform-ai/ai-map/index.vue'),
                meta: { title: '观全域' }
            },
            {
                path: '/ai-problem',
                name: 'ai-problem',
                component: () => import(/* webpackChunkName: "ai-problem" */ '../views/platform-ai/ai-problem/index.vue'),
                meta: { title: '看问题' }
            },
            {
                path: '/ai-report',
                name: 'ai-report',
                component: () => import(/* webpackChunkName: "ai-report" */ '../views/platform-ai/ai-report/index.vue'),
                meta: { title: '出报告' }
            }
        ]
    },
    {
        path: '/ai-ask',
        name: 'ai-ask',
        component: () => import(/* webpackChunkName: "ai-ask" */ '../views/platform-ai/ai-ask/index.vue'),
        meta: { title: 'AI-问答' }
    },
    {
        path: '/ai-problem-unprocessed',
        name: 'ai-problem-unprocessed',
        component: () => import(/* webpackChunkName: "ai-problem-unprocessed" */ '../views/platform-ai/ai-problem/component/unprocessed/index.vue'),
        meta: { title: '看问题详情' }
    },
    {
        path: '/ai-problem-disposal',
        name: 'ai-problem-disposal',
        component: () => import(/* webpackChunkName: "ai-problem-disposal" */ '../views/platform-ai/ai-problem/component/disposal/index.vue'),
        meta: { title: '看问题处置报告' }
    },
    {
        path: '/ai-report-detail',
        name: 'ai-report-detail',
        component: () => import(/* webpackChunkName: "ai-report-detail" */ '../views/platform-ai/ai-report/component/detail/index.vue'),
        meta: { title: '出报告详情' }
    },
    {
        path: '/large-data-screen',
        name: 'large-data-screen',
        component: () => import(/* webpackChunkName: "LargeDataScreen" */ '../views/large-data-screen/index.vue'),
        meta: { title: '数据看板' },
        children: []
    }
]

const router = createRouter({
    routes: asyncRouterConfig,
    history: createWebHistory(import.meta.env.MODE === 'dev' ? './' : './'),
    scrollBehavior(to, from, savedPosition) {
        return { top: 0 }
    }
})

export default router
